"use strict";

import $ from "jquery";
import "slick-carousel";

export default class HighlightsCarousel {
  constructor() {
    let $highlights = $(".highlights-carousel-wrap");

    this.$highlights = $highlights;

    $highlights.slick({
      infinite: true,
      arrows: true,
      prevArrow:
        '<button class="slick-arrow slick-prev"><span class="icon icon-angle-left"></span><span class="label"></span></button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><span class="label"></span><span class="icon icon-angle-right"></span></button>',
      appendArrows: $(".highlights-carousel__nav"),
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 10000,
    });
  }
}
